import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static values = {
    title: String,
    content: String,
    url: String,
    method: String,
  };

  open(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    const title = this.titleValue || "Confirmation";
    const content = this.contentValue || "";
    const actionUrl = this.urlValue;
    const httpMethod = this.methodValue || "POST";

    Fancybox.show(
      [
        {
          src: `
          <div class="fx-modal-container">
            <div class="fx-modal-header">
              <h3>${title}</h3>
            </div>
            <form id="dynamic-confirm-form">
              <div class="fx-modal-body">
                ${content}
              </div>
              <div class="fx-modal-footer">
                <button type="button" id="fancybox-confirm-no" class="fx-button fx-button-cancel">
                  <i class="fas fa-times"></i> Annuler
                </button>
                <button type="submit" id="fancybox-confirm-yes" class="fx-button fx-button-success">
                  <i class="fas fa-check"></i> Confirmer
                </button>
              </div>
            </form>
          </div>
        `,
          type: "html",
        },
      ],
      {
        dragToClose: false,
        click: false,
        keyboard: false,
      },
    );

    setTimeout(() => {
      const form = document.getElementById("dynamic-confirm-form");
      const btnNo = document.getElementById("fancybox-confirm-no");

      if (btnNo) {
        btnNo.onclick = () => {
          document.activeElement.blur();
          Fancybox.close();
        };
      }

      if (form) {
        form.onsubmit = (e) => {
          e.preventDefault();
          if (!form.checkValidity()) {
            form.reportValidity();
            return;
          }
          this.submitData(form, actionUrl, httpMethod);
        };
      }
    }, 100);
  }

  async submitData(form, url, method) {
    const btnYes = document.getElementById("fancybox-confirm-yes");
    const formData = new FormData(form);
    const csrfToken = document.querySelector(
      'meta[name="csrf-token"]',
    )?.content;

    if (btnYes) btnYes.disabled = true;

    try {
 
      if (this.showLoader) this.showLoader();

      const response = await fetch(url, {
        method: method.toUpperCase(),
        headers: {
          "X-CSRF-Token": csrfToken,
          Accept: "text/javascript, application/javascript, application/json",
        },
        body: formData,
      });

      if (response.ok) {
        const contentType = response.headers.get("Content-Type"); 
        // if (window.showFlash) {
        //   window.showFlash("success", "Opération réussie");
        // }

        if (contentType && contentType.includes("javascript")) {
          const script = await response.text();
          eval(script);
          Fancybox.close();
        } else if (response.redirected) {
          window.location.href = response.url;
        } else {
          Fancybox.close();
          window.location.reload();
        }
      } else {
        if (window.showFlash) {
          window.showFlash("error", "Une erreur est survenue lors de l'envoi.");
        } else {
          alert("Une erreur est survenue.");
        }
        if (btnYes) btnYes.disabled = false;
      }
    } catch (error) {
      console.error("Erreur:", error);
      if (window.showFlash) window.showFlash("error", "Erreur réseau.");
      if (btnYes) btnYes.disabled = false;
    } finally { 
      if (this.hideLoader) this.hideLoader();
    }
  }

} 